/* BulkPlug Supply. Native Shopify forms are the checkout source of truth. */
(() => {
'use strict';
function bind(root = document) {
root.querySelectorAll('[data-quantity]').forEach((control) => {
if (control.dataset.bound) return;
control.dataset.bound = 'true';
control.querySelectorAll('[data-qty-change]').forEach((button) => {
button.addEventListener('click', () => {
const input = control.querySelector('input');
const min = Number(input.min || 0), step = Number(input.step || 1), max = input.max ? Number(input.max) : Infinity;
input.value = String(Math.max(min, Math.min(max, Number(input.value || min) + Number(button.dataset.qtyChange) * step)));
input.dispatchEvent(new Event('change', {bubbles:true}));
});
});
});
root.querySelectorAll('[data-product-section]').forEach((section) => {
if (section.dataset.bound) return;
section.dataset.bound = 'true';
const select = section.querySelector('[data-variant-select]');
const image = section.querySelector('#ProductMainImage');
function setImage(src, alt) {
if (!image || !src) return;
image.removeAttribute('srcset'); image.removeAttribute('sizes');
image.src = src; image.alt = alt || '';
}
section.querySelectorAll('[data-image-url]').forEach((button) => button.addEventListener('click', () => setImage(button.dataset.imageUrl, button.dataset.imageAlt)));
function updateVariant(updateUrl) {
const option = select?.selectedOptions[0];
if (!option) return;
const available = option.dataset.available === 'true';
const add = section.querySelector('[data-add-button]');
const quantity = section.querySelector('[name="quantity"]');
section.querySelector('[data-price]').textContent = option.dataset.price;
section.querySelector('[data-sku]').textContent = option.dataset.sku ? `SKU: ${option.dataset.sku}` : '';
add.disabled = !available; add.textContent = available ? 'Add to cart' : 'Sold out';
const min = Number(option.dataset.min || 1), step = Number(option.dataset.increment || 1);
quantity.min = String(min); quantity.step = String(step);
if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
let next = min + Math.max(0, Math.ceil((Number(quantity.value || min) - min) / step)) * step;
if (option.dataset.max) next = Math.min(next, Number(option.dataset.max));
quantity.value = String(next);
const notes = [];
if (min > 1) notes.push(`Minimum quantity: ${min}.`);
if (step > 1) notes.push(`Quantity increments: ${step}.`);
if (option.dataset.max) notes.push(`Maximum quantity: ${option.dataset.max}.`);
section.querySelector('[data-quantity-note]').textContent = notes.join(' ');
setImage(option.dataset.image, option.dataset.alt);
if (updateUrl && window.history.replaceState) {
const url = new URL(window.location.href); url.searchParams.set('variant', option.value);
window.history.replaceState({}, '', url);
}
}
select?.addEventListener('change', () => updateVariant(true));
updateVariant(false);
});
const cart = root.querySelector('#CartForm');
if (cart && !cart.dataset.bound) {
cart.dataset.bound = 'true';
cart.addEventListener('keydown', (event) => {
if (event.key === 'Enter' && event.target.matches('input[name="updates[]"]')) {
event.preventDefault(); const button = cart.querySelector('[name="update"]');
cart.requestSubmit ? cart.requestSubmit(button) : button.click();
}
});
}
}
bind();
document.addEventListener('shopify:section:load', (event) => bind(event.target));
document.addEventListener('keydown', (event) => {
if (event.key !== 'Escape') return;
document.querySelectorAll('.bp-mobile-menu[open], .bp-nav-dropdown[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); });
});
document.addEventListener('click', (event) => {
document.querySelectorAll('.bp-mobile-menu[open], .bp-nav-dropdown[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
});
})();